export default __webpack_public_path__ + "static/media/dashboard-img.9d4bd329.png";